var map = {
	"./扶梯1.png": "405e",
	"./扶梯2.png": "342d1",
	"./扶梯3.png": "b8e0",
	"./扶梯4.png": "4443",
	"./扶梯5.png": "4b62",
	"./扶梯6.png": "f3e4",
	"./扶梯7.png": "8d7b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "26af";